import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=3f6aadde&scoped=true&"
import script from "./personal.vue?vue&type=script&lang=ts&"
export * from "./personal.vue?vue&type=script&lang=ts&"
import style0 from "./personal.vue?vue&type=style&index=0&id=3f6aadde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6aadde",
  null
  
)

export default component.exports